import { render, staticRenderFns } from "./FailedPhysicianDuties.vue?vue&type=template&id=05f4bd24&"
import script from "./FailedPhysicianDuties.vue?vue&type=script&lang=js&"
export * from "./FailedPhysicianDuties.vue?vue&type=script&lang=js&"
import style0 from "./FailedPhysicianDuties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports